module.exports = __webpack_public_path__ + "static/customize3-2d1b9c3c61025dda6c35e4d93171bb4b.png";